<template>
  <div class="home-container">
    <Watermark/>
    <!-- 侧边栏 -->
    <div class="sidebar" :class="{ collapse: isCollapse }">
      <div class="logo" @click="toggleCollapse">
        <div class="logo-img-wrapper">
          <img src="@/assets/logo2.png" alt="logo">
        </div>
        <span v-show="!isCollapse">船期管理系统</span>
      </div>
      <el-menu :default-active="activeMenu" :collapse="isCollapse" :default-openeds="openedMenus"   unique-opened
        :collapse-transition="false" text-color="black" active-text-color="#409EFF" router>
        <!-- 动态渲染菜单 -->
        <template v-for="menu in menuList">
          <el-submenu v-if="menu.children && menu.children.length > 0" :key="menu.id" :index="menu.path || menu.id">
            <template slot="title">
              <svg-icon v-if="menu.icon" :icon-class="menu.icon" class="menu-icon" />
              <i v-else :class="menu.icon || 'el-icon-menu'"></i>
              <span slot="title">{{ menu.pmsName }}</span>
            </template>
            <el-menu-item v-for="child in menu.children" :key="child.id" :index="child.path">
              <svg-icon v-if="child.icon" :icon-class="child.icon" class="menu-icon" />
              <i v-else :class="child.icon || 'el-icon-document'"></i>
              <span slot="title">{{ child.pmsName }}</span>
            </el-menu-item>
          </el-submenu>
          <el-menu-item v-else :key="menu.id + ''" :index="menu.path">
            <svg-icon v-if="menu.icon" :icon-class="menu.icon" class="menu-icon" />
            <i v-else :class="menu.icon || 'el-icon-menu'"></i>
            <span slot="title">{{ menu.pmsName }}</span>
          </el-menu-item>
        </template>
      </el-menu>
      <div class="sidebar-footer" v-show="!isCollapse">power by hhyt</div>
      <div class="sidebar-footer" v-show="isCollapse">hhyt</div>
    </div>
    <!-- 主内容区 -->
    <div class="main-container">
      <div class="header">
        <div class="header-left">
          <el-button type="text" @click="toggleCollapse" icon="el-icon-s-fold" style="font-size: 20px;" />
          <div class="breadcrumb">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item>{{ currentTitle }}</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </div>
        <div class="header-right">
          <el-badge :value="unreadCount" :hidden="unreadCount === 0" class="message-badge" :offset="[5, 5]">
            <el-button type="text" @click="toggleMessageDrawer" icon="el-icon-bell" class="message-bell"></el-button>
          </el-badge>
          <el-dropdown trigger="hover" :hide-timeout="800" :show-timeout="150" @command="handleCommand">
            <span class="user-info">
              <span>{{ userName }}<template v-if="enName">({{ enName }})</template></span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="changePwd">修改密码</el-dropdown-item>
              <el-dropdown-item command="changeEmail">修改邮箱</el-dropdown-item>
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <div v-show="messageDrawerVisible" class="message-drawer" ref="messageDrawer">
            <el-tabs v-model="activeTab" @tab-click="handleTabClick">
              <el-tab-pane label="未读消息" name="unread">
                <div class="message-toolbar">
                  <el-button type="primary" size="small" @click="markAllAsRead"
                    v-if="unreadMessages.length">全部已读</el-button>
                </div>
                <div class="message-list">
                  <div v-for="(msg, idx) in unreadMessages" :key="msg.id" class="message-item"
                    @click="showMessageDetail(msg, idx)">
                    <div class="message-header">
                      <div class="message-title">{{ msg.title }}</div>
                      <el-button type="text" size="small" class="read-btn" @click.stop="markMessageAsRead(msg, idx)">
                        标记已读
                      </el-button>
                    </div>
                    <div class="message-preview" :title="getNoticePreview(msg)">{{ getNoticePreview(msg) }}</div>
                    <div class="message-time">{{ msg.createTime }}</div>
                  </div>
                  <div v-if="unreadMessages.length === 0" class="empty-message">暂无未读消息</div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="所有消息" name="all">
                <div class="message-list" @scroll="scrollHandler">
                  <div v-for="msg in allMessagesList" :key="msg.id" class="message-item"
                    @click="showMessageDetail(msg)">
                    <div class="message-header">
                      <div class="message-title">标题: {{ msg.title }}</div>
                      <div class="message-time">{{ msg.createTime }}</div>
                    </div>
                    <div class="message-preview" :title="getNoticePreview(msg)">{{ getNoticePreview(msg) }}</div>
                  </div>
                  <div v-if="allMessagesList.length === 0 && !allMessagesPage.loading" class="empty-message">暂无消息</div>
                  <div v-if="allMessagesPage.loading" class="loading-more">
                    <i class="el-icon-loading"></i> 加载中...
                  </div>
                  <div v-if="!allMessagesPage.hasMore && allMessagesList.length > 0" class="no-more">
                    没有更多了
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
          <el-dialog title="修改密码" :visible.sync="changePwdDialogVisible" width="400px" :close-on-click-modal="false">
            <el-form :model="pwdForm" :rules="pwdRules" ref="pwdFormRef" label-width="100px">
              <el-form-item label="旧密码" prop="oldPwd">
                <el-input type="password" v-model="pwdForm.oldPwd" placeholder="请输入旧密码" show-password></el-input>
              </el-form-item>
              <el-form-item label="新密码" prop="newPwd">
                <el-input type="password" v-model="pwdForm.newPwd" placeholder="请输入新密码" show-password></el-input>
              </el-form-item>
              <el-form-item label="确认新密码" prop="confirmPwd">
                <el-input type="password" v-model="pwdForm.confirmPwd" placeholder="请再次输入新密码" show-password></el-input>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="changePwdDialogVisible = false">取消</el-button>
              <el-button type="primary" @click="submitChangePwd" :loading="changePwdLoading">确定</el-button>
            </span>
          </el-dialog>
          <el-dialog title="修改邮箱" :visible.sync="changeEmailDialogVisible" width="400px" :close-on-click-modal="false">
            <el-form :model="emailForm" :rules="emailRules" ref="emailFormRef" label-width="80px">
              <el-form-item label="邮箱" prop="email">
                <el-input v-model="emailForm.email" placeholder="请输入邮箱" maxlength="100" />
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="changeEmailDialogVisible = false">取消</el-button>
              <el-button type="primary" @click="submitChangeEmail" :loading="changeEmailLoading">确定</el-button>
            </span>
          </el-dialog>
        </div>
      </div>
      <div class="content" :class="{ 'content--scrollable': contentScrollable }">
        <keep-alive :include="cachedViews">
          <router-view />
        </keep-alive>
      </div>
    </div>
    <notice-toast-stack ref="noticeStack" @notice-read="onNoticeRead" @notice-displayed="onNoticeDisplayed"
      @notices-batch-read="onNoticesBatchRead" @close-drawer="messageDrawerVisible = false"/>
  </div>
</template>
<script>
import userApi from '@/api/user.js'
import noticeApi from '@/api/notice.js'
import wsManager from '@/utils/websocket'
import { resetDynamicRoutesFlag, pathToComponentName } from '@/router/routeRegistry'
import Watermark from '../views/components/Watermark/index.vue'
import NoticeToastStack from '@/components/notice/NoticeToastStack.vue'
import { getNoticePreview as formatNoticePreview } from '@/utils/noticeHelper'

export default {
  name: 'Home',
  components: {
    Watermark,
    NoticeToastStack
  },
  data() {
    const validateConfirmPwd = (rule, value, callback) => {
      if (value !== this.pwdForm.newPwd) {
        callback(new Error('两次输入的新密码不一致'))
      } else {
        callback()
      }
    }
    return {
      cachedViews: [], // 最近访问的组件 name 列表，最多保留 3 个（LRU）
      isCollapse: false,
      userName: '读取中.',
      enName: '',
      menuList: [],
      inFindMenu: false,
      openedMenus: [], // 保存展开的菜单
      changePwdDialogVisible: false,
      changePwdLoading: false,
      changeEmailDialogVisible: false,
      changeEmailLoading: false,
      inLoadNotice: false,
      allMessagesPage: {
        page: 1,
        size: 10,
        total: 0,
        hasMore: true,
        loading: false
      },
      allMessagesList: [], // 所有消息列表（用于滚动加载）
      pwdForm: {
        oldPwd: '',
        newPwd: '',
        confirmPwd: ''
      },
      emailForm: {
        email: ''
      },
      pwdRules: {
        oldPwd: [
          { required: true, message: '请输入旧密码', trigger: 'blur' }
        ],
        newPwd: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, max: 20, message: '密码长度在6-20个字符之间', trigger: 'blur' }
        ],
        confirmPwd: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: validateConfirmPwd, trigger: 'blur' }
        ]
      },
      emailRules: {
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱格式', trigger: ['blur', 'change'] }
        ]
      },
      unreadCount: 0,
      messageDrawerVisible: false,
      activeTab: 'unread',
      unreadMessages: [],
      allMessages: [],
      scrollTimer: null,
      reloadNoticeTimer: null,
      isLoadingMore: false
    }
  },
  computed: {
    activeMenu() {
      var p = this.$route.path
      if (p.startsWith("/")) {
        p = p.substring(1, p.length)
      }
      return p
    },
    currentTitle() {
      return this.$route.meta.title || ''
    },
    /** 非固定布局页保留主内容区滚动（订单列表等 fixedLayout 页禁用外层滚动） */
    contentScrollable() {
      if (this.$route.meta.fixedLayout) return false
      const path = this.$route.path
      return path !== '/myOrders' && path !== '/businessOrders'
    },
    displayMessages() {
      return this.activeTab === 'unread' ? this.unreadMessages : this.allMessagesList
    }
  },
  created() {
    this.fetchData()
    this.loadMenus()
  },
  watch: {
    // 监听路由，始终保持当前菜单展开 + 缓存最近 3 个页面
    '$route': {
      handler(to) {
        this.updateOpenMenu(to.path)
        // 缓存逻辑：根据路由 path 查映射表得到组件 name，超过 3 个淘汰最早的
        const pathKey = to.path.replace(/^\//, '')
        const compName = pathToComponentName[pathKey] || pathKey
        if (compName) {
          // 订单三页不进 keep-alive，每次点菜单重新拉数
          if (compName === 'MyList' || compName === 'BusinessCenter' || compName === 'BusinessCenter2'
              || pathKey === 'myOrders' || pathKey === 'businessOrders' || pathKey === 'businessOrders2') {
            return
          }
          const idx = this.cachedViews.indexOf(compName)
          if (idx > -1) {
            // 已缓存，移到末尾（LRU：最近使用的放最后）
            this.cachedViews.splice(idx, 1)
          }
          this.cachedViews.push(compName)
          if (this.cachedViews.length > 3) {
            this.cachedViews.shift()
          }
        }
      },
      immediate: true
    },
    unreadMessages: {
      handler(newVal) {
        this.unreadCount = newVal.length
      },
      deep: true
    }
  },
  mounted() {
    // 添加全局点击监听
    document.addEventListener('click', this.handleClickOutside)
    // 监听页面关闭或刷新时断开WebSocket
    window.addEventListener('beforeunload', this.handleBeforeUnload)
    wsManager.onMessageType('reloadNotice', this.reloadNotice)
  },
  beforeDestroy() {
    // 移除监听
    document.removeEventListener('click', this.handleClickOutside)
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
    if (this.scrollTimer) {
      clearTimeout(this.scrollTimer)
    }
    if (this.reloadNoticeTimer) {
      clearTimeout(this.reloadNoticeTimer)
    }
    wsManager.offMessageType('reloadNotice')
  },
  methods: {
    reloadNotice() {
      if (this.reloadNoticeTimer) {
        clearTimeout(this.reloadNoticeTimer)
      }
      this.reloadNoticeTimer = setTimeout(() => {
        this.reloadNoticeTimer = null
        this.doReloadNotice()
      }, 400)
    },
    doReloadNotice() {
      // WS 推送时直接拉取待弹窗消息，避免 unread 计数滞后导致漏弹
      noticeApi.unreadNoticeNum().then((res) => {
        if (res.code == 200) {
          this.unreadCount = res.data
        }
      })
      this.fetchOpenNotices(true)
    },
    checkNotice() {
      noticeApi.unreadNoticeNum().then((res) => {
        if (res.code == 200) {
          this.unreadCount = res.data
          if (res.data > 0) {
            this.fetchOpenNotices(false)
          }
        }
      })
    },
    /** 拉取 auto_open=1 的未读消息并入队展示；WS 触发时可重试一次应对入库时序差 */
    fetchOpenNotices(retryOnEmpty = false) {
      noticeApi.queryMyOpenNotices().then((res) => {
        if (res.code != 200 || !this.$refs.noticeStack) return
        if (res.data && res.data.length > 0) {
          this.$refs.noticeStack.enqueue(res.data)
        } else if (retryOnEmpty) {
          setTimeout(() => {
            noticeApi.queryMyOpenNotices().then((retryRes) => {
              if (retryRes.code == 200 && retryRes.data && retryRes.data.length > 0 && this.$refs.noticeStack) {
                this.$refs.noticeStack.enqueue(retryRes.data)
              }
            })
          }, 400)
        }
      })
    },
    fetchData() {
      var userInfoStr = localStorage.getItem('userInfo')
      if (userInfoStr) {
        var userInfo = JSON.parse(userInfoStr)
        this.userName = userInfo.userName
        this.enName = userInfo.enName
      }
      this.checkNotice()
    },
    onNoticeRead(noticeId) {
      const idx = this.unreadMessages.findIndex(m => m.id === noticeId)
      if (idx !== -1) {
        this.unreadMessages.splice(idx, 1)
        this.unreadCount = this.unreadMessages.length
      }
    },
    /** 「稍后处理-全部」：队列消息批量已读后同步未读列表与角标 */
    onNoticesBatchRead(ids) {
      if (!ids || !ids.length) return
      const idSet = new Set(ids)
      this.unreadMessages = this.unreadMessages.filter(m => !idSet.has(m.id))
      noticeApi.unreadNoticeNum().then((res) => {
        if (res.code == 200) {
          this.unreadCount = res.data
        } else {
          this.unreadCount = this.unreadMessages.length
        }
      }).catch(() => {
        this.unreadCount = this.unreadMessages.length
      })
    },
    onNoticeDisplayed() {
      const c = this.unreadCount - 1
      this.unreadCount = c <= 0 ? 0 : c
    },
    async refreshUnreadMessages() {
      const res = await noticeApi.queryMyNotices({ isAll: 0, current: 1, size: 100 })
      if (res.code == 200) {
        this.unreadMessages = res.data.records || []
        this.unreadCount = this.unreadMessages.length
      }
    },
    toggleMessageDrawer() {
      this.messageDrawerVisible = !this.messageDrawerVisible
      if (this.messageDrawerVisible) {
        if (this.activeTab === 'unread') {
          this.refreshUnreadMessages()
        } else {
          this.resetAndLoadAllMessages()
        }
      }
    },
    resetAndLoadAllMessages() {
      this.allMessagesPage = {
        page: 1,
        size: 10,
        total: 0,
        hasMore: true,
        loading: false
      }
      this.allMessagesList = []
      this.loadAllMessages()
    },
    async loadAllMessages() {
      if (this.allMessagesPage.loading || !this.allMessagesPage.hasMore) return
      this.allMessagesPage.loading = true
      this.isLoadingMore = true
      try {
        const res = await noticeApi.queryMyNotices({
          isAll: 1,
          current: this.allMessagesPage.page,
          size: this.allMessagesPage.size
        })
        if (res.code == 200) {
          const newMessages = res.data.records || []
          this.allMessagesList = [...this.allMessagesList, ...newMessages]
          this.allMessagesPage.total = res.data.total || 0
          this.allMessagesPage.hasMore = this.allMessagesList.length < this.allMessagesPage.total
          this.allMessagesPage.page++
        }
      } catch (error) {
        console.error('加载消息失败:', error)
      } finally {
        this.allMessagesPage.loading = false
        this.isLoadingMore = false
        console.log('加载完毕.')
      }
    },
    scrollHandler(event) {
      if (this.activeTab !== 'all') return
      if (this.isLoadingMore || !this.allMessagesPage.hasMore) return
      const { scrollTop, scrollHeight, clientHeight } = event.target
      // 距离底部50px时加载下一页
      if (scrollTop + clientHeight >= scrollHeight - 50) {
        if (this.scrollTimer) clearTimeout(this.scrollTimer)
        this.scrollTimer = setTimeout(() => {
          this.loadAllMessages()
        }, 200)
      }
    },
    handleBeforeUnload() {
      // 页面关闭时断开WebSocket
      wsManager.logout()
    },
    async markMessageAsRead(message, index) {
      try {
        const res = await noticeApi.readNotice(message.id)
        if (res.code == 200) {
          // 从未读列表中移除
          this.unreadMessages.splice(index, 1)
          this.unreadCount = this.unreadMessages.length
          return true
        } else {
          this.$message.error(res.msg || '标记已读失败')
          return false
        }
      } catch (error) {
        console.error('标记已读失败:', error)
        this.$message.error('标记已读失败')
        return false
      }
    },
    showMessageDetail(msg, index) {
      if (this.$refs.noticeStack) {
        this.$refs.noticeStack.clearQueue()
        const markRead = this.activeTab === 'unread' && index !== undefined
        this.$refs.noticeStack.showOne(msg, { markRead })
      }
    },
    getNoticePreview(msg) {
      return formatNoticePreview(msg)
    },
    handleClickOutside(event) {
      if (this.messageDrawerVisible) {
        const drawer = this.$refs.messageDrawer
        const messageBtn = document.querySelector('.message-bell')
        // 判断点击是否在消息弹窗外部且不是点击的消息按钮
        if (drawer && !drawer.contains(event.target) &&
          messageBtn && !messageBtn.contains(event.target)) {
          this.messageDrawerVisible = false
        }
      }
    },
    handleTabClick(tab) {
      if (tab.name == 'unread') {
        this.refreshUnreadMessages()
      } else {
        this.resetAndLoadAllMessages()
      }
    },
    markAllAsRead() {
      if (this.unreadMessages.length === 0) {
        this.$message.info('没有未读消息')
        return
      }
      noticeApi.allRead().then((res) => {
        if (res.code == 200) {
          this.unreadMessages = []
          this.unreadCount = 0
          this.$message.success('已将所有消息标记为已读')
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    setPath(path) {
      if (path.startsWith('home')) {
        return path
      } else {
        return 'home/' + path
      }
    },
    generateRoutes(menuList) {
      const routes = []
      menuList.forEach(menu => {
        if (menu.path && menu.children && menu.children.length === 0) {
          const route = {
            path: menu.path,
            name: menu.pmsName,
            component: () => this.moduleMap[menu.path],
            meta: { title: menu.pmsName }
          }
          routes.push(route)
        }
        if (menu.children && menu.children.length > 0) {
          const childRoutes = this.generateRoutes(menu.children)
          routes.push(...childRoutes)
        }
      })
      return routes
    },
    loadMenus() {
      const menusStr = localStorage.getItem('userMenus')
      this.menuList = []
      if (menusStr) {
        this.menuList = JSON.parse(menusStr)
        this.$nextTick(() => {
          this.updateOpenMenu(this.$route.path)
        })
      } else {
        userApi.getUserMenu().then(res => {
          this.menuList = res.data
          localStorage.setItem('userMenus', JSON.stringify(this.menuList))
          this.$nextTick(() => {
            this.updateOpenMenu(this.$route.path)
          })
        })
      }
    },
    // 递归查找父菜单，保证展开
    updateOpenMenu(currentPath) {
      if (this.inFindMenu) return;
      this.inFindMenu = true
      if (currentPath.startsWith('/')) {
        currentPath = currentPath.substring(1, currentPath.length)
      }
      const findParent = (menus) => {
        for (const item of menus) {
          if (item.children && item.children.length) {
            const isChildActive = item.children.some(child => child.path === currentPath)
            if (isChildActive) {
              this.openedMenus = [item.path || item.id]
              this.inFindMenu = false
              return
            }
            findParent(item.children)
          }
        }
        this.inFindMenu = false
      }
      findParent(this.menuList)
    },
    toggleCollapse() {
      this.isCollapse = !this.isCollapse
    },
    async handleCommand(command) {
      if (command === 'logout') {
        try { await userApi.logout() } catch (err) { }
        resetDynamicRoutesFlag()
        localStorage.removeItem('token')
        localStorage.removeItem('userInfo')
        localStorage.removeItem('userMenus')
        localStorage.removeItem('pms')
        this.menuList = []
        this.$router.push('/login')
      } else if (command === 'changePwd') {
        this.changePwdDialogVisible = true
        // 重置表单
        this.$nextTick(() => {
          if (this.$refs.pwdFormRef) {
            this.$refs.pwdFormRef.resetFields()
          }
        })
        this.pwdForm = {
          oldPwd: '',
          newPwd: '',
          confirmPwd: ''
        }
      } else if (command === 'changeEmail') {
        let currentEmail = ''
        try {
          const raw = localStorage.getItem('userInfo')
          const info = raw ? JSON.parse(raw) : {}
          currentEmail = info.email || ''
        } catch (e) {}
        this.emailForm = { email: currentEmail }
        this.changeEmailDialogVisible = true
        this.$nextTick(() => {
          if (this.$refs.emailFormRef) {
            this.$refs.emailFormRef.clearValidate()
          }
        })
      }
    },
    submitChangePwd() {
      this.$refs.pwdFormRef.validate(async (valid) => {
        if (!valid) return
        this.changePwdLoading = true
        try {
          var res = await userApi.resetMyPwd({
            oldPwd: this.pwdForm.oldPwd,
            newPwd: this.pwdForm.newPwd
          })
          if (res.code == 200) {
            this.$message.success('密码修改成功，请重新登录')
            this.changePwdDialogVisible = false
          } else {
            this.$message.error(res.msg)
          }
        } catch (error) {
          this.$message.error(error.message || '密码修改失败')
        } finally {
          this.changePwdLoading = false
        }
      })
    },
    submitChangeEmail() {
      this.$refs.emailFormRef.validate(async (valid) => {
        if (!valid) return
        this.changeEmailLoading = true
        try {
          const email = String(this.emailForm.email || '').trim()
          const res = await userApi.upMyEmail({ email })
          if (res.code == 200) {
            try {
              const raw = localStorage.getItem('userInfo')
              const info = raw ? JSON.parse(raw) : {}
              info.email = email
              localStorage.setItem('userInfo', JSON.stringify(info))
            } catch (e) {}
            this.$message.success('邮箱修改成功')
            this.changeEmailDialogVisible = false
          } else {
            this.$message.error(res.msg || '邮箱修改失败')
          }
        } catch (error) {
          this.$message.error(error.message || '邮箱修改失败')
        } finally {
          this.changeEmailLoading = false
        }
      })
    },
  }
}
</script>
<style scoped>
.home-container {
  display: flex;
  height: 98vh;
}

.sidebar {
  background: linear-gradient(180deg, #05a7f5 0%, #04cffde3 100%);
  background-size: 100% 200%;
  backdrop-filter: blur(10px);
  box-shadow: 2px 0 20px rgba(0, 0, 0, 0.1);
  width: 200px;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  border-bottom-right-radius: 15px;
  border-top-right-radius: 15px;
  overflow: hidden;
  overflow-y: auto;
}

.sidebar::-webkit-scrollbar {
  display: none;
  /* 隐藏滚动条 */
}

.sidebar.collapse {
  width: 64px;
}

.sidebar.collapse .sidebar-footer {
  display: none;
}

.logo {
  height: 50px;
  line-height: 50px;
  text-align: center;
  color: white;
  font-size: 18px;
  font-weight: bold;
  background-color: #2b2f3a;
}

.message-wrapper {
  position: relative;
  margin-right: 20px;
  display: inline-block;
  vertical-align: middle;
}

/* 调整badge位置 */
.message-badge {
  position: relative;
  top: -2px;
  /* 调整垂直位置 */
}

::v-deep .message-badge .el-badge__content {
  top: 0;
  right: 0;
}

/* 或者调整具体的偏移量 */
.message-badge ::v-deep .el-badge__content {
  top: 8px;
  /* 往上偏移 */
  right: 8px;
  /* 往右偏移 */
}

.el-menu {
  border-right: none;
}

.main-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.header {
  height: 50px;
  background: white;
  border-bottom: 1px solid #e6e6e6;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  border-radius: 15px;
}

.header-left {
  display: flex;
  align-items: center;
}

.breadcrumb {
  margin-left: 20px;
}

.user-info {
  cursor: pointer;
  color: #666;
}

.content {
  flex: 1;
  min-height: 0;
  background: #e8eff3;
  overflow: hidden;
  position: relative;
  background: linear-gradient(90deg, #97e4f5 0%, #e6f5f9 25%, #ecf5f7 100%);
  border-bottom-left-radius: 15px;
  border-top-left-radius: 15px;
}

.content.content--scrollable {
  overflow: auto;
}

.menu-icon {
  width: 20px;
  height: 20px;
  margin-right: 5px;
}

/* 子菜单缩进 */
::v-deep .el-submenu .el-menu-item {
  padding-left: 80px !important;
}

::v-deep .el-menu-item.is-active {
  /* background-color: #1379c1 !important; 选中背景加深 */
  background: linear-gradient(90deg, rgb(5 95 189 / 30%), rgba(64, 158, 255, .1)) !important;
  color: #fff !important;
  /* 文字变白 */
  border-left: 3px solid #3491c9 !important;
  /* 左侧蓝色选中条 */
}

/* 子菜单 hover 效果 */
::v-deep .el-submenu .el-menu-item:hover {
  background-color: #1379c1 !important;
  color: #fff !important;
}

.el-submenu__title {
  font-size: 16px !important;
}

.sidebar.collapse ::v-deep .el-menu-item i,
.sidebar.collapse ::v-deep .el-submenu__title i {
  margin-right: 0;
}

.sidebar.collapse ::v-deep .el-menu {
  background-color: #05a7f5 !important;
  /* 与侧边栏主色调保持一致 */
}

.sidebar ::v-deep .el-menu {
  scrollbar-width: thin;
}

.sidebar ::v-deep .el-menu::-webkit-scrollbar {
  width: 4px;
}

.sidebar ::v-deep .el-menu::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 2px;
}

.sidebar ::v-deep .el-menu::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
}

.logo {
  height: 50px;
  padding: 0 15px;
  display: flex;
  align-items: center;
  color: white;
  font-size: 18px;
  font-weight: bold;
  overflow: hidden;
  border-top-right-radius: 15px;
  background: linear-gradient(90deg, #6aa9e0 0%, #08b1f3ef 100%);
  cursor: pointer;
  transition: all 0.3s ease;
}

.logo:hover {
  background: linear-gradient(90deg, #6aa9e0 0%, #08b1f3ef 100%);
  transform: scale(1.02);
}

.sidebar {
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

::v-deep .el-menu-item,
::v-deep .el-submenu__title {
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(-10px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.logo-img-wrapper {
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-img-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.logo span {
  flex-shrink: 0;
  white-space: nowrap;
  user-select: none;
}

.sidebar {
  position: relative;
  border-bottom-right-radius: 15px;
  border-top-right-radius: 15px;
}

.sidebar-footer {
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
  text-align: center;
  color: rgba(255, 255, 255, 0.5);
  font-size: 16px;
  font-weight: bold;
  user-select: none;
}

/* 消息铃铛样式 */
.message-badge {
  margin-right: 20px;
}

.message-bell {
  font-size: 20px;
  color: #666;
}

/* 消息弹框样式 */
.message-drawer {
  position: absolute;
  top: 50px;
  right: 10px;
  width: 350px;
  max-height: 500px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  z-index: 1000;
  overflow: hidden;
  padding: 0 20px;
  border: 1px solid #b3b3b3;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);
}

.message-list {
  max-height: 400px;
  overflow-y: auto;
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* IE 10+ */
  margin-bottom: 30px;
}

.message-list::-webkit-scrollbar {
  display: none;
  /* Chrome Safari */
}

.message-item {
  padding: 12px 15px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background-color 0.3s;
}

.message-item:hover {
  background-color: #f5f7fa;
}

.message-title {
  font-weight: bold;
  margin-bottom: 5px;
  color: #333;
  text-align: left;
}

.message-preview {
  font-size: 12px;
  color: #999;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
}

.message-toolbar {
  padding-bottom: 5px;
  border-bottom: 1px solid #e6e6e6;
  text-align: right;
}

.empty-message {
  text-align: center;
  padding: 40px 20px;
  color: #999;
}

::v-deep .el-menu-item,
::v-deep .el-submenu__title {
  position: relative;
  user-select: none;
  transition: all 0.3s ease;
}

::v-deep .el-menu-item::after,
::v-deep .el-submenu__title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 15%;
  width: 70%;
  height: 1px;
  background: linear-gradient(90deg,
      transparent 0%,
      rgba(255, 255, 255, 0.3) 20%,
      rgba(255, 255, 255, 0.6) 50%,
      rgba(255, 255, 255, 0.3) 80%,
      transparent 100%);
}

::v-deep .el-menu-item:hover,
::v-deep .el-submenu__title:hover {
  background-color: rgba(255, 255, 255, 0.15) !important;
  transform: translateX(4px);
}

::v-deep .el-submenu__title i {
  color: #ffffff !important;
  right: 40px;
}

.message-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.message-title {
  font-weight: bold;
  color: #333;
  flex: 1;
}

.read-btn {
  color: #409eff;
  font-size: 12px;
  padding: 0;
}

.read-btn:hover {
  color: #66b1ff;
}

.message-time {
  font-size: 12px;
  color: black;
  margin-top: 5px;
  text-align: right;
}

.loading-more,
.no-more {
  text-align: center;
  padding: 15px;
  color: #999;
  font-size: 12px;
}

.loading-more i {
  margin-right: 5px;
}

.message-item {
  padding: 8px 10px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background-color 0.3s;
}

.message-item:hover {
  background-color: #f5f7fa;
}

/* 滚动条样式优化 */
.message-list::-webkit-scrollbar {
  width: 6px;
}

.message-list::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.message-list::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.message-list::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

::v-deep .el-menu--vertical {
  background-color: #05a7f5 !important;
}

::v-deep .sidebar .el-menu {
  background-color: transparent !important;
}

.sidebar.collapse .el-menu {
  background: linear-gradient(180deg, #05a7f5 0%, #04cffde3 100%) !important;
}
</style>